export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#4D6354" />
    <circle cx="32" cy="32" r="29" fill="none" stroke="#C49A5A" strokeWidth="1.5" />
    <text
      x="32"
      y="41"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontSize="24"
      fill="#FAF9F5"
      textAnchor="middle"
      fontStyle="italic"
    >
      CD
    </text>
  </svg>
);
